import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Modal from './Modal';

const EditModal = (props) => {
    const {
        t,
        isOpen,
        onClose,
        onConfirm,
        textBtnConfirm,
        textBtnClose,
        loadingOnConfirm,
        reverseButtons,
        className,
        labelConfirm,
        secondLabelConfirm,
        isDisabled,
        title,
        disableCancel,
        btnconfirmType,
        btnConfirmName,
        beneficiaryData = {},
    } = props;

    const validationSchema = Yup.object().shape({
        name: Yup.string(),
        lastname: Yup.string(),
        email: Yup.string().email(t('validationEmail')),
        documentId: Yup.string(),
    });

    const initialValues = {
        name: '',
        lastname: '',
        email: '',
        documentId: '',
    };

    const handleConfirm = (values) => {
        const updatedValues = {
            name: values.name || beneficiaryData.name,
            lastname: values.lastname || beneficiaryData.lastname,
            email: values.email || beneficiaryData.email,
            documentId: values.documentId || beneficiaryData.documentId,
        };

        onConfirm(updatedValues);
    };

    return (
      <Modal
        className={className}
        isOpen={isOpen}
        onClose={onClose}
        title={t(title)}
        centered
        type="info"
        buttons={[
            {
                name: btnConfirmName || 'confirmation',
                text: textBtnConfirm,
                action: handleConfirm,
                isLoading: loadingOnConfirm,
                disabled: isDisabled,
                type: btnconfirmType,
            },
            !disableCancel && {
                name: 'confirmClose',
                text: textBtnClose,
                action: onClose,
            },
        ].filter(Boolean)}
        headerButtons={false}
        reverseButtons={reverseButtons}
        backDrop={false}
      >
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleConfirm}
          >
              {() => (
                <Form className="confirm-modal">
                    <p>{t(labelConfirm)}</p>
                    {secondLabelConfirm && <p className="second-label">{t(secondLabelConfirm)}</p>}
                    <div className="edit-fields">
                        <div className="edit-name">
                            <label>
                                {t('Firstname')}
                                <Field type="text" name="name" placeholder={t('InputFirstname')} />
                                <ErrorMessage name="name" component="div" className="error" />
                            </label>
                        </div>
                        <div className="edit-lastname">
                            <label>
                                {t('Lastname')}
                                <Field type="text" name="lastname" placeholder={t('InputLastname')} />
                                <ErrorMessage name="lastname" component="div" className="error" />
                            </label>
                        </div>
                        <div className="edit-email">
                            <label>
                                {t('Mail')}
                                <Field type="email" name="email" placeholder={t('InputMail')} />
                                <ErrorMessage name="email" component="div" className="error" />
                            </label>
                        </div>
                        <div className="edit-documentId">
                            <label>
                                {t('DocumentID')}
                                <Field type="text" name="documentId" placeholder={t('InputDocumentID')} />
                                <ErrorMessage name="documentId" component="div" className="error" />
                            </label>
                        </div>
                    </div>
                </Form>
              )}
          </Formik>
      </Modal>
    );
};

EditModal.defaultProps = {
    isOpen: false,
    onClose: () => {},
    onConfirm: () => {},
    textBtnConfirm: 'buttonSave',
    textBtnClose: 'buttonCancel',
    labelConfirm: 'modalEditMsg',
    reverseButtons: true,
    closeRight: true,
    loadingOnConfirm: true,
    isDisabled: null,
    title: 'modalEditTitle',
    disableCancel: false,
};

EditModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    textBtnConfirm: PropTypes.string,
    textBtnClose: PropTypes.string,
    labelConfirm: PropTypes.string,
    reverseButtons: PropTypes.bool,
    loadingOnConfirm: PropTypes.bool,
    isDisabled: PropTypes.func,
    title: PropTypes.string,
    disableCancel: PropTypes.bool,
    beneficiaryData: PropTypes.shape({
        name: PropTypes.string,
        lastname: PropTypes.string,
        email: PropTypes.string,
        documentId: PropTypes.string,
    }),
};

export default withNamespaces()(EditModal);
